// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3mlnu","error":"Textarea_error__1zxkf","readonly":"Textarea_readonly__1wuSF","disabled":"Textarea_disabled__3fDHo"};